import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const QualityInitiatives = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='obj-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Objectives</h1>
        </div>
      </div>


      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Objective of the IQAC</button>
        {
          isOpen && (
            <div className='obj-items'>
              <h3>Quality Initiatives</h3>
              <p></p>
              <p></p>
              <p>
                ✬ Contacts through e-mail and SMS alert for meetings and schedules to be followed for MQC members, Heads and Coordinators</p>
              <p>
                ✬ Paperless communication from the Office of IQAC to submit the following Reports</p>
              <p>
                ✬ Self Appraisal form from the faculty</p>
              <p>
                ✬ Academic Audit Report</p>
              <p>
                ✬ Evaluative Report of the Departments and different Units of the College</p>
              <p>
                ✬ Minutes of the meetings held in IQAC</p>
              <p></p>
              <p></p>

              <h3>Changes and Improvements are made over the previous questionnaire for</h3>
              <p></p>
              <p></p>
              <p>
                ✬
                Evaluation of Faculty by Students.</p>
              <p>
                ✬ Public Forum</p>
              <p></p>
              <p></p>
              <h3>Supply of Proforma / Template for submitting</h3>
              <p></p>
              <p></p>
              <p>
                ✬
                Self Appraisal of an Individual Faculty</p>
              <p>
                ✬ Annual Academic Audit</p>
            </div>
          )

        }

      </div>

      <h3 style={{ textAlign: 'center', marginBottom: '40px' }}>Internal Quality Assurance System</h3>

      <table>
        <tr>
          <th> Year</th>
          <th>Name of quality initiative by IQAC</th>
          <th>Duration (from-to)</th>
        </tr>
        <tr>
          <td>2019 - 2020</td>
          <td>Performance Appraisal of Teaching Faculty</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Performance Appraisal of Non-Teaching Faculty</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Students Satisfaction Survey (Online)</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Briefing and Demo: NAAC SSR Data Entry Portal to Deans, Heads, Coordinators & Micro Quality Circle (MQC) members</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Steps in Formulating Programme Education Objectives (PEOs)</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Digital Academic Planner - Online Portal</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Shifting Grounds in Higher Education Today & Future, New Vistas in NAAC Accreditation</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Administrators Retreat</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Draft Committee on Policies of The New College</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	College Website revamping</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Initiating towards establishing a department of Human Excellence</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Preparation of Research Project Proposal & Writing Scientific / Research Articles</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Staff Seminar on 'A Paradigm Shift in Assessment and Accreditation Process of NAAC</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Policy Preparation on Vision Mission Value Statements</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Feedback through Google forms.</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Curriculum Design, Evaluation Reforms, Research etc</td>
          <td></td>
        </tr>
        <tr>
          <td>2018 - 2019</td>
          <td>Workshop - Art of wirting Research Paper and Funding</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Workshop - Faculty Development Programme</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Workshop - Curriculum Designing and Teaching Learning Enhancement</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Awareness programme - Drugs  and Addiction: Do you know enuogh</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Workshop - Quality and Accreditation: Students Perspective</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>National Conference on Higher Education in the Knowledge Age: Techno Pedagogical Perspectives & Innovations</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Review Meeting on E-Content Development</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Policy Preparation on ICT</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	SSR Initiation Committee Meeting</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Digital Visibility & its Implications in research & Nuances in NAAC Accreditation</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Feedback for Revision of NAAC Manual & Guidelines</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Capacity Building Workshop for Faculty on E-Content Development</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Parent - Teachers' Meeting</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>NIRF 2018</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Concept Paper Discussion on ICT in deliverance in Governance</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Administrator & Officials Meeting - Retreat</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Interactive Meeting on Funding Project Preparation</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Faculty Enhancement Workshop on Digital Age Pedagogy</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Top-Up Skills For Junior Staff CIA ReformsFaculty Enhancement Workshop on Digital Age Pedagogy</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Annual Academic Audit (AAA)</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>	Inventory Audit</td>
          <td></td>
        </tr>
      </table>

      <Footer />
    </div>
  );
}

export default QualityInitiatives;
